import styled from "styled-components";
import { colors } from "assets";

export default c => styled(c)`
  .close-icon {
    color: red;
  }

  .done-icon {
    color: ${colors.primary.dark};
  }

  .paper {
    padding: 12px;
    margin: 8px 0px;
  }

  .user-found {
    text-align: right;
    padding: 8px;
    margin: 0px;
  }

  .row {
    margin-bottom: 8px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/app/support/company/company-show/style.js